import { Switch } from '@odekoteam/doppio';
import { useEffect, useState } from 'react';
import { UPDATE_LOCATIONS_ENFORCE_ITEM_SCANNING } from 'src/graphql/requests/updateLocationsEnforceItemScanning';
import { GUpdateLocationsEnforceItemScanningMutation } from 'src/graphql/types/generated';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { routingLocationsSelector } from 'src/state/selectors/locations';
import { updateRoutingLocations } from 'src/state/slices/locations';
import { Flex } from 'theme-ui';
import { useMutation } from 'urql';

const EnforceItemScanningSwitch = ({
  locationId,
  value,
}: {
  locationId: string;
  value?: boolean;
}): JSX.Element => {
  const routingLocations = useAppSelector(routingLocationsSelector);
  const dispatch = useAppDispatch();
  const locationInState = routingLocations.find(
    (location) => location.locationId === locationId,
  );
  const [isChecked, setIsChecked] = useState(
    locationInState ? locationInState.enforceItemScanning : value,
  );
  const [isDisabled, setIsDisabled] = useState(false);
  const [
    updateLocationsEnforceItemScanningResult,
    updateLocationsEnforceItemScanning,
  ] = useMutation<GUpdateLocationsEnforceItemScanningMutation>(
    UPDATE_LOCATIONS_ENFORCE_ITEM_SCANNING,
  );

  const handleSwitch = (newValue: boolean): void => {
    if (!isDisabled) {
      updateLocationsEnforceItemScanning({
        input: {
          locationIds: [locationId],
          enforceItemScanning: newValue,
        },
      });
      // optimistic load
      setIsChecked(newValue);
      dispatch(
        updateRoutingLocations([
          {
            locationId,
            enforceItemScanning: newValue,
          },
        ]),
      );
      // debounce
      setIsDisabled(true);
    }
  };

  useEffect(() => {
    const enforceItemScanning =
      updateLocationsEnforceItemScanningResult?.data
        ?.updateLocationsEnforceItemScanning?.locations[0].enforceItemScanning;
    if (enforceItemScanning !== undefined) {
      // if the mutation fails - update the switch
      setIsChecked(enforceItemScanning);
      dispatch(
        updateRoutingLocations([
          {
            locationId,
            enforceItemScanning,
          },
        ]),
      );
      setIsDisabled(false);
    }
  }, [
    updateLocationsEnforceItemScanningResult?.data
      ?.updateLocationsEnforceItemScanning?.locations,
  ]);

  const getLabel = (): string => {
    if (isChecked) return 'On';
    else return 'Off';
  };
  return (
    <Flex>
      <Switch
        id={`enforce-item-scanning-switch-${locationId}`}
        accessibilityLabel="enforce item scanning toggle"
        onCheckedChange={handleSwitch}
        size="default"
        isChecked={isChecked}
      />
      <span sx={{ marginLeft: '12px', variant: 'text.paragraphLgDefault' }}>
        {getLabel()}
      </span>
    </Flex>
  );
};

export default EnforceItemScanningSwitch;
